interface ScopeLabelProps {
  isMultiCompanyGroup: boolean;
  isConsolidatedView: boolean;
  alwaysGroup?: boolean;
  alwaysCompany?: boolean;
}

export function ScopeLabel({
  isMultiCompanyGroup,
  isConsolidatedView,
  alwaysGroup,
  alwaysCompany,
}: ScopeLabelProps) {
  if (!isMultiCompanyGroup) return null;

  let label: string;
  if (alwaysGroup) label = "Group";
  else if (alwaysCompany) label = "Company";
  else label = isConsolidatedView ? "Group" : "Company";

  return (
    <span className="text-xs font-normal text-muted-foreground ml-1">
      ({label})
    </span>
  );
}
